const HireDevelopmentPort = 4206;
const AdminDevelopmentPort = 4216;
const SPADevelopmentPort = 3000;
const InspireDevelopmentPort = 4208;
/**
 * Port mappings for local development ports.  These are the ports used to access FE clients
 * when running the angular dev servers for each app.
 */
export const DevelopmentPorts = {
    hire: HireDevelopmentPort,
    admin: AdminDevelopmentPort,
    spa: SPADevelopmentPort,
    inspire: InspireDevelopmentPort
};
